import userStore from 'stores/UserStore.js';

/**
 * Utility to check if the current user can access the FDS pages.
 *
 * @return {boolean} Bool of whether user has the proper role to access the FDS pages.
 */

function userCanAccessFds() {
  const allowedRoles = ['settlement-internal', 'settlement-view-and-edit'];

  return allowedRoles.some((role) => userStore.hasRole(role));
}

export { userCanAccessFds };
